
import React, { useMemo } from 'react';
import { Node } from 'slate'
import {ErrorBoundary} from 'react-error-boundary';
import styled from 'styled-components';

import { noop } from 'utils'

function ErrorFallback({error}) {
    return (
        <div role="alert">
        <p>Something went wrong:</p>
        <pre style={{color: 'red'}}>{error.message}</pre>
        </div>
    )
}

 const BaseElement = React.forwardRef(({ className, element, type, children, contentStyle, showPlaceholder, textAlign, BaseElementComponent = 'div', ...attributes }, ref) => {
    const [content, hasVariable, hasImage] = useMemo(() => {
        const children = Array.from(Node.elements(element));

        const hasVariable = children.some(([c]) => c.type === 'variable');
        const hasImage = children.some(([c]) => c.type === 'image');

        return [Node.string(element), hasVariable, hasImage]
    },
        [element]
    );

    const isEmpty = useMemo(() => showPlaceholder && !hasVariable && !hasImage && !content.length, [showPlaceholder, content]);

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <div 
                {...attributes} 
                ref={ref}
                className={className}
                data-element-id={element._id} 
                data-element-type={type} 
            >   
                <BaseElementComponent 
                    element={element}
                    type={type}
                    content={content}
                    hasVariable={hasVariable}
                    hasImage={hasImage}
                    isEmpty={isEmpty}
                >
                    <div 
                        className="item-wrapper position-relative" 
                        style={{ ...contentStyle, textAlign: textAlign || element.textAlign }} 
                        type={type} 
                    >
                        {children({ isEmpty })}
                    </div> 
                </BaseElementComponent>
            </div>
        </ErrorBoundary>
    )
})

export default BaseElement;


function BaseElementNoEditableField({ className, children, style }) {

    return (
        <span className={className}  contentEditable={false} style={{...style, userSelect: 'none'}} suppressContentEditableWarning> {/*style={{ userSelect: "none" }}*/}
            {children}
        </span>
    )
}

const StyledBaseElementNoEditableField = styled(BaseElementNoEditableField)`
    font-weight: ${props => props.fontWeight || 'normal'};
    font-size: ${props => props.fontSize || '12px'};
`

function BaseElementPlaceholder({ text, style }) {
    return (
        <span
            className="text-muted"
            contentEditable="false"
            suppressContentEditableWarning
            style={{
                pointerEvents: 'none',
                display: 'inline-block',
                width: '0',
                maxWidth: '100%',
                whiteSpace: 'nowrap',
                opacity: 0.333,
                position: 'absolute',
                height: 0,
                ...style
            }}
        >
            {text}
        </span>
    )
}

BaseElement.NoEditableField = StyledBaseElementNoEditableField;
BaseElement.Placeholder = BaseElementPlaceholder;

// export const withBaseElement = () => (editor) => {
//     const { normalizeNode } = editor;
  
//     editor.normalizeNode = ([currentNode, currentPath]) => {
        
//         if (currentNode.type === 'table-wrap') {
//             console.log({currentNode, currentPath})
//             Transforms.setNodes(editor, {
//                 children: [{
//                     type: 'base_element',
//                     children: currentNode.children,
//                 }]
//             }, {
//                 at: currentPath
//             })
//         }

//       return normalizeNode([currentNode, currentPath]);
//     };
  
//     return editor;
//   };

// export function renderBaseElement(params) {
//     return (props) => {
//       if (props.element.type === 'base_element') { 
//         return (
//             <BaseElement {...props} {...params} />
//         );
//       }
    
//       return undefined;
//     }
//   }
  
//   export const BaseElementPlugin = ({ setCurrentElement = noop } = {}) => ({
//     renderElement: renderBaseElement({ setCurrentElement }),
//   });